<div class="modal-container">
    <div class="flex flex-space-between">
        <div class="head-font mt-2">Booking Details</div>
        <mat-icon class="close-icon cursor-pointer" (click)="dialogRef.close(false)"
                  aria-hidden="false"
                  aria-label="close icon"
                  iconPositionEnd
                  mat-dialog-close>close
        </mat-icon>
    </div>

    <div class="subhead-font flex justify-content-between">
        <div class="mt-2">Booking ID: {{tourBooking?.Id}}</div>
        <span [class]="'status-badge ' + tourBooking?.Status?.toLowerCase()">{{tourBooking?.Status}}</span>
    </div>
    <div class="line"></div>

    <div class="label-font mt-2 w-100">Customer Information</div>
    <div class="flex mt-2 justify-content-between">
        <div>
            <div class="label-font">Customer Name</div>
            <div class="value-font mt-2">{{tourBooking?.CustomerName}}</div>
        </div>
        <div class="w-50">
            <div class="label-font">Number of Guests</div>
            <div class="value-font mt-2">{{tourBooking?.Guests}}</div>
        </div>
    </div>

    <div class="flex mt-2 justify-content-between">
        <div>
            <div class="label-font">Booking Date</div>
            <div class="value-font mt-2">{{tourBooking?.BookingDate}}</div>
        </div>
        <div class="w-50">
            <div class="label-font">Total Amount</div>
            <div class="value-font mt-2">{{tourBooking?.TotalAmount}}</div>
        </div>
    </div>
    <div class="line"></div>

    <div class="label-font mt-2 w-100">Activity Information</div>
    <div class="flex mt-2 justify-content-between">
        <div>
            <div class="label-font">Activity</div>
            <div class="value-font mt-2">{{tourBooking?.TourName}}</div>
        </div>
        <div class="w-50">
            <div class="label-font">Scheduled Date</div>
            <div class="value-font mt-2">{{tourBooking?.ScheduledAt}}</div>
        </div>
    </div>

    <div class="mt-2">
        <div class="label-font">Operator</div>
        <div class="value-font mt-2">{{tourBooking?.OperatorName}}</div>
    </div>
    <div class="line"></div>

    <div class="label-font mt-2 w-100">Redemption Information</div>
    <div class="flex mt-2 justify-content-between">
        <div>
            <div class="label-font">Redemption Code</div>
            <div class="redemption-code mt-2">{{tourBooking?.RedemptionCode}}</div>
        </div>
        <div class="w-50">
            <div class="label-font">Redeemed</div>
            <div class="flex mt-2">
                <img *ngIf="tourBooking?.Redeemed?.includes('Yes')" src="/XpressApp/assets/images/experience/icons/icon-green-check-in-circle.svg" width="24" height="24" alt="">
                <div class="value-font" [ngClass]="{'ml-2 redeem-date': tourBooking?.Redeemed?.includes('Yes')}">{{tourBooking?.Redeemed}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="tourBooking?.Status !== 'Cancelled' || (tourBooking?.Status === 'Cancelled' && !tourBooking?.CancelReason)" class="line"></div>
    <div *ngIf="tourBooking?.Status === 'Cancelled' && tourBooking?.CancelReason" class="cancellation-reason">
        <div class="label-font cancellation-color">Cancellation Reason</div>
        <div class="value-font mt-2">{{tourBooking?.CancelReason}}</div>
    </div>

    <div class="flex cursor-pointer mb-1 mt-3" (click)="viewAuditTrail()">
        <img class="mr-2 mt-1" width="18" height="18" src="/XpressApp/assets/images/experience/icons/icon-view-audit.svg" alt="file" />
        <div class="btn-font">View Audit Trail</div>
    </div>
</div>

<ng-template #auditTrail>
    <div class="modal-container">
        <div class="flex flex-space-between">
            <div class="head-font mt-2">Audit Trail</div>
            <mat-icon class="close-icon cursor-pointer" (click)="closeAuditTrail()"
                      aria-hidden="false"
                      aria-label="close icon"
                      iconPositionEnd
                      mat-dialog-close>close
            </mat-icon>
        </div>

        <div class="subhead-font flex justify-content-between">
            <div class="mt-2">Booking ID: {{tourBooking?.Id}}</div>
            <span [class]="'status-badge ' + tourBooking?.Status?.toLowerCase()">{{tourBooking?.Status}}</span>
        </div>
        <div class="line"></div>

        <div class="flex mt-2 mb-2 justify-content-between">
            <div class="label-font">Booking Created</div>
            <div class="value-font">{{tourBooking?.BookingDate}}</div>
        </div>
        <div class="line"></div>

        <div class="flex mt-2 mb-2 justify-content-between">
            <div class="label-font">Payment Confirmed</div>
            <div class="value-font">{{tourBooking?.PaymentConfirmed}}</div>
        </div>
        <div class="line"></div>
    </div>
</ng-template>
